module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent",
    staticStyle: {
      "position": "absolute"
    }
  }, [_c('mu-appbar', [_c('span', {
    staticClass: "topT"
  }, [_vm._v("我的订单")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-tabs', {
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "tab1",
      "title": "当前订单"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab2",
      "title": "历史订单"
    }
  })], 1), _vm._v(" "), (_vm.activeTab === 'tab1') ? _c('div', {
    on: {
      "touchmove": function($event) {
        return _vm.loadPage(1)
      },
      "touchend": function($event) {
        return _vm.loadEnd(1)
      }
    }
  }, [_c('mu-refresh-control', {
    attrs: {
      "refreshing": _vm.refreshing[0],
      "trigger": _vm.trigger[0]
    },
    on: {
      "refresh": function($event) {
        return _vm.refresh(1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#F5F5F5",
      "height": "0.2rem"
    }
  }), _vm._v(" "), _vm._l((_vm.List1), function(item) {
    return _c('div', {
      staticStyle: {
        "width": "92%",
        "margin": "0 auto 0 auto"
      }
    }, [_c('div', {
      staticClass: "Grey",
      on: {
        "click": function($event) {
          return _vm.goDetail(item.ParentResvNo, item.TotalPrice, '取消订单')
        }
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "height": "0.7rem"
      }
    }, [_c('span', {
      staticClass: "Orange",
      staticStyle: {
        "margin-left": "5px",
        "margin-top": "10px",
        "font-weight": "700",
        "font-size": "0.28rem",
        "float": "left"
      }
    }, [(item.State === 'NW') ? _c('div', [_vm._v(" 应到未到 ")]) : _vm._e(), _vm._v(" "), (item.State === 'C0') ? _c('div', [_vm._v(" 取消成功 ")]) : _vm._e(), _vm._v(" "), (item.State === 'C1') ? _c('div', [_vm._v(" 退款失败 ")]) : _vm._e(), _vm._v(" "), (item.State === 'C2') ? _c('div', [_vm._v(" 正在退款 ")]) : _vm._e(), _vm._v(" "), (item.State === 'R2') ? _c('div', [_vm._v(" 交易中")]) : _vm._e(), _vm._v(" "), (item.State === 'R1') ? _c('div', [_vm._v(" 交易失败 ")]) : _vm._e(), _vm._v(" "), (item.State === 'R999') ? _c('div', [_vm._v(" 已入住 ")]) : _vm._e(), _vm._v(" "), (item.State === 'R0' && item.listResvPayInfo[0].PayStatus != '0') ? _c('div', [_vm._v(" 预订成功 ")]) : _vm._e(), _vm._v(" "), (item.State === 'booking888') ? _c('div', [_vm._v(" 预订 ")]) : _vm._e(), _vm._v(" "), (item.State === 'R0' && item.listResvPayInfo[0].PayStatus == '0') ? _c('div', [_vm._v(" 已支付 ")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-right": "10px",
        "margin-top": "10px",
        "font-size": "0.24rem",
        "float": "right"
      }
    }, [_vm._v("\n              查看详情   >\n            ")])]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "border": "none",
        "border-top": "1px solid #F1F1F1"
      }
    }), _vm._v(" "), _c('table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "align": "center",
        "border": "0"
      }
    }, [_c('tr', [_vm._m(0, true), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "color": "#333333",
        "font-weight": "700",
        "width": "98%"
      }
    }, [_vm._v(" " + _vm._s(item.HotelName) + " ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-top": "0.1rem",
        "line-height": "1.6",
        "font-size": "0.22rem",
        "float": "left"
      }
    }, [_vm._v("\n                  入住： " + _vm._s(_vm._f("dayTime")(item.Arrivedate)) + "\n                  "), _c('br'), _vm._v(" 离开： " + _vm._s(_vm._f("dayTime")(item.Departuredate)) + "\n                  "), _c('br'), _vm._v(" 房型： " + _vm._s(item.RoomTypeNameNew + '(' + item.RoomTypeDisPlayNew + ')') + " × " + _vm._s(item.RoomCount) + "\n                ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#333333",
        "float": "right",
        "margin": "0.2rem 0.15rem 0 0"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "0.26rem"
      }
    }, [_vm._v(" ￥ ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "0.32rem"
      }
    }, [_vm._v(" " + _vm._s(item.TotalPrice) + " ")])])])])]), _vm._v(" "), (item.IsRelax) ? _c('div', [_c('hr', {
      staticStyle: {
        "border": "none",
        "border-top": "1px solid #F1F1F1"
      }
    }), _vm._v(" "), (item.listResvPayInfo[0].PayStatus == '0') ? _c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "0.21rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.2rem"
      }
    }, [_vm._v("\n              备注：休闲房订单取消需提前到达时间4小时以上！\n            ")]) : _vm._e(), _vm._v(" "), (item.listResvPayInfo[0].PayStatus != '0') ? _c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "0.21rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.2rem"
      }
    }, [_vm._v("\n              备注：该房间需在30分钟内完成支付，未完成支付将自动取消。\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!item.IsRelax) ? _c('div', [_c('hr', {
      staticStyle: {
        "border": "none",
        "border-top": "1px solid #F1F1F1"
      }
    }), _vm._v(" "), (item.listResvPayInfo[0].PayStatus == '0') ? _c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "0.21rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.2rem"
      }
    }, [_vm._v("\n              备注：如遇特殊情况，不能及时入住，您可以在\n              "), _c('span', {
      staticClass: "Orange",
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v("【入住当日】18:00 ")]), _vm._v("\n              前免费取消订单。若未入住或过时取消，将收取您首日房费。\n            ")]) : _vm._e(), _vm._v(" "), (item.listResvPayInfo[0].PayStatus != '0' && item.IsSpecialRoom == false) ? _c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "0.21rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.2rem"
      }
    }, [_vm._v("\n              备注：如您到店较晚，建议您先支付房费，我们为您保留房间至\n              "), (
      this.Card_Kind_Diplay == '员工卡' || this.Card_Kind_Diplay == '数字卡' || this.Card_Kind_Diplay == '贵宾卡'
    ) ? _c('span', {
      staticClass: "Orange",
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v("【退房当日】13:00 ")]) : _vm._e(), _vm._v(" "), (
      this.Card_Kind_Diplay == '贝壳卡' || this.Card_Kind_Diplay == '铂金卡' || this.Card_Kind_Diplay == '金卡' || this.Card_Kind_Diplay == '翡翠卡' || this.Card_Kind_Diplay == '联名卡'
    ) ? _c('span', {
      staticClass: "Orange",
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v("【退房当日】14:00 ")]) : _vm._e(), _vm._v("\n              ，期间可随时入住。\n              "), _c('span', {
      staticClass: "Orange",
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v("【入住当日】18:00 ")]), _vm._v("\n              之前取消订单可全额退款。超时或未入住将收取您首日房费。\n            ")]) : _vm._e(), _vm._v(" "), (item.listResvPayInfo[0].PayStatus != '0' && item.IsSpecialRoom == true) ? _c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "0.21rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.2rem"
      }
    }, [_vm._v("\n              备注：特价房需要在30分钟内完成支付，未完成支付将自动取消。\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('hr', {
      staticStyle: {
        "border": "none",
        "border-top": "1px solid #F1F1F1"
      }
    })]), _vm._v(" "), ((item.State === 'R0' && item.listResvPayInfo[0].PayStatus != '0') || item.State === 'R2') ? _c('div', {
      staticStyle: {
        "height": "0.7rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.1rem"
      }
    }, [_c('div', {
      staticStyle: {
        "border": "1px solid #27ba69",
        "color": "#27ba69",
        "text-align": "center",
        "width": "1.67rem",
        "height": "0.57rem",
        "float": "right"
      },
      on: {
        "click": function($event) {
          return _vm.goPayMoney(item.ParentResvNo, item.TotalPrice, item.HoldTime)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "padding-top": "0.1rem",
        "font-size": "0.24rem"
      }
    }, [_vm._v(" 支付房费 ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "0.3rem",
        "height": "0.57rem",
        "float": "right"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "border": "1px solid #cccccc",
        "color": "#999999",
        "text-align": "center",
        "width": "1.67rem",
        "height": "0.57rem",
        "float": "right"
      },
      on: {
        "click": function($event) {
          return _vm.CancelOrder(item.ParentResvNo)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "padding-top": "0.1rem",
        "font-size": "0.24rem"
      }
    }, [_vm._v(" 取消订单 ")])])]) : _vm._e(), _vm._v(" "), (item.State === 'R0' && item.listResvPayInfo[0].PayStatus == '0') ? _c('div', {
      staticStyle: {
        "height": "0.7rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.1rem"
      }
    }, [_c('div', {
      staticStyle: {
        "border": "1px solid #cccccc",
        "color": "#999999",
        "text-align": "center",
        "width": "1.67rem",
        "height": "0.57rem",
        "float": "right"
      },
      on: {
        "click": function($event) {
          return _vm.CancelOrder(item.ParentResvNo)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "padding-top": "0.1rem",
        "font-size": "0.24rem"
      }
    }, [_vm._v(" 取消订单 ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#F5F5F5",
        "height": "0.2rem",
        "width": "114%",
        "margin-left": "-7%"
      }
    })])
  }), _vm._v(" "), (!_vm.loadState[0]) ? _c('div', {
    staticClass: "load",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_vm._v(" " + _vm._s(_vm.loadMsg[0]) + " ")]) : _vm._e(), _vm._v(" "), (_vm.loadState[0]) ? _c('div', {
    staticClass: "loading"
  }, [(this.loadMsg[0] != '加载中...') ? _c('img', {
    staticStyle: {
      "width": "1.2rem",
      "margin-top": "2.1rem"
    },
    attrs: {
      "src": require("../../../static/LoadingWhite.gif")
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  }) : _vm._e(), _vm._v(" "), (this.loadMsg[0] == '加载中...') ? _c('img', {
    staticStyle: {
      "width": "1.2rem"
    },
    attrs: {
      "src": require("../../../static/LoadingWhite.gif")
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 2) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'tab2') ? _c('div', {
    on: {
      "touchmove": function($event) {
        return _vm.loadPage(2)
      },
      "touchend": function($event) {
        return _vm.loadEnd(2)
      }
    }
  }, [(this.loadMsg[1] != '') ? _c('mu-refresh-control', {
    attrs: {
      "refreshing": _vm.refreshing[1],
      "trigger": _vm.trigger[1]
    },
    on: {
      "refresh": function($event) {
        return _vm.refresh(2)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#F5F5F5",
      "height": "0.2rem"
    }
  }), _vm._v(" "), _vm._l((_vm.List2), function(item) {
    return _c('div', {
      staticStyle: {
        "width": "92%",
        "margin": "0 auto 0 auto"
      }
    }, [_c('div', {
      staticClass: "Grey",
      on: {
        "click": function($event) {
          return _vm.goDetail(item.ParentResvNo, item.TotalPrice, '删除订单')
        }
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "height": "0.7rem"
      }
    }, [_c('span', {
      staticClass: "Orange",
      staticStyle: {
        "margin-left": "5px",
        "margin-top": "10px",
        "font-weight": "700",
        "font-size": "0.28rem",
        "float": "left"
      }
    }, [(item.State === 'NW') ? _c('div', [_vm._v(" 应到未到 ")]) : _vm._e(), _vm._v(" "), (item.State === 'C0') ? _c('div', [_vm._v(" 取消成功 ")]) : _vm._e(), _vm._v(" "), (item.State === 'C1') ? _c('div', [_vm._v(" 退款失败 ")]) : _vm._e(), _vm._v(" "), (item.State === 'C2') ? _c('div', [_vm._v(" 正在退款 ")]) : _vm._e(), _vm._v(" "), (item.State === 'R2') ? _c('div', [_vm._v(" 交易中")]) : _vm._e(), _vm._v(" "), (item.State === 'R1') ? _c('div', [_vm._v(" 交易失败 ")]) : _vm._e(), _vm._v(" "), (item.State === 'R999') ? _c('div', [_vm._v(" 已入住 ")]) : _vm._e(), _vm._v(" "), (item.State === 'R0') ? _c('div', [_vm._v(" 预订成功 ")]) : _vm._e(), _vm._v(" "), (item.State === 'booking888') ? _c('div', [_vm._v(" 预订 ")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-right": "10px",
        "margin-top": "10px",
        "font-size": "0.24rem",
        "float": "right"
      }
    }, [_vm._v("\n              查看详情   >\n            ")])]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "border": "none",
        "border-top": "1px solid #F1F1F1"
      }
    }), _vm._v(" "), _c('table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "align": "center",
        "border": "0"
      }
    }, [_c('tr', [_vm._m(1, true), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "color": "#333333",
        "font-weight": "700",
        "width": "98%"
      }
    }, [_vm._v(" " + _vm._s(item.HotelName) + " ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "1.6",
        "font-size": "0.22rem",
        "float": "left"
      }
    }, [_vm._v("\n                  入住： " + _vm._s(_vm._f("dayTime")(item.Arrivedate)) + "\n                  "), _c('br'), _vm._v(" 离开： " + _vm._s(_vm._f("dayTime")(item.Departuredate)) + "\n                  "), _c('br'), _vm._v(" 房型： " + _vm._s(item.RoomTypeNameNew + '(' + item.RoomTypeDisPlayNew + ')') + " × " + _vm._s(item.RoomCount) + "\n                ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#333333",
        "float": "right",
        "margin": "0.2rem 0.15rem 0 0"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "0.26rem"
      }
    }, [_vm._v(" ￥ ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "0.32rem"
      }
    }, [_vm._v(" " + _vm._s(item.TotalPrice) + " ")])])])])]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "border": "none",
        "border-top": "1px solid #F1F1F1"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.7rem",
        "margin-top": "0.2rem",
        "margin-bottom": "0.1rem"
      }
    }, [_c('div', {
      staticStyle: {
        "border": "1px solid #cccccc",
        "color": "#999999",
        "text-align": "center",
        "width": "1.67rem",
        "height": "0.57rem",
        "float": "right"
      },
      on: {
        "click": function($event) {
          return _vm.DeleteOrder(item.ParentResvNo)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "padding-top": "0.1rem",
        "font-size": "0.24rem"
      }
    }, [_vm._v(" 删除订单 ")])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#F5F5F5",
        "height": "0.2rem",
        "width": "114%",
        "margin-left": "-7%"
      }
    })])
  }), _vm._v(" "), (!_vm.loadState[1]) ? _c('div', {
    staticClass: "load",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_vm._v(" " + _vm._s(_vm.loadMsg[1]) + " ")]) : _vm._e(), _vm._v(" "), (_vm.loadState[1]) ? _c('div', {
    staticClass: "loading"
  }, [(this.loadMsg[1] != '加载中...') ? _c('img', {
    staticStyle: {
      "width": "1.2rem",
      "margin-top": "2.1rem"
    },
    attrs: {
      "src": require("../../../static/LoadingWhite.gif")
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  }) : _vm._e(), _vm._v(" "), (this.loadMsg[1] == '加载中...') ? _c('img', {
    staticStyle: {
      "width": "1.2rem"
    },
    attrs: {
      "src": require("../../../static/LoadingWhite.gif")
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 2) : _vm._e()], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog,
      "title": ""
    },
    on: {
      "close": _vm.closeNO
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#666666"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.dialogMsg) + "\n    ")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flat-button', {
    staticStyle: {
      "background-color": "#cccccc",
      "color": "white"
    },
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "取消"
    },
    on: {
      "click": _vm.closeNO
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flat-button', {
    staticStyle: {
      "background-color": "#27BA69",
      "color": "white"
    },
    attrs: {
      "slot": "actions",
      "label": "确定"
    },
    on: {
      "click": _vm.closeYES
    },
    slot: "actions"
  })], 1)])])]), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "26%"
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "1.2rem",
      "max-width": "1.6rem",
      "margin": "-5% 0 0 -5%"
    },
    attrs: {
      "src": require("../../../static/order/LOGO_021003_4.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "26%"
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "1.2rem",
      "max-width": "1.6rem",
      "margin": "-5% 0 0 -5%"
    },
    attrs: {
      "src": require("../../../static/order/LOGO_021003_4.jpg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1404df87!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/IndexToOther.vue
// module id = 1425
// module chunks = 18